import {SearchOptions} from "@/components/FaqSearch/SearchOptions";
import {KeywordList} from "@/components/FaqSearch/KeywordList";
import React from "react";
import {FaqHooks} from "@/types/faq";
import {useFaqSearch} from "@/stores/faqSearch";

export const SearchConditionContainer = ({faqHooks}: { faqHooks: FaqHooks }) => {
  const {searchText, setSearchText} = useFaqSearch()
  return (
    <div className="faq-search-condition uk-margin-top">
      <div className="uk-flex">
        <input
          className="input-search uk-width-1-2"
          onChange={event => setSearchText(event.target.value)}
          value={searchText}
        />
        <button className="button-search margin-left-32" onClick={faqHooks.onClickSearch}>検索</button>
      </div>
      <div className="uk-flex uk-margin-top">
        <button
          className={faqHooks.isShowSearchOptions ? "button-minus" : "button-plus"}
          onClick={faqHooks.onClickSearchOptions}
        >
          検索オプションを表示
        </button>
        <button
          className={
            (faqHooks.isShowKeywordList ? "button-minus" : "button-plus") +
            " margin-left-32"
          }
          onClick={faqHooks.onClickKeywordList}
        >
          キーワードを表示
        </button>
      </div>
      {faqHooks.isShowSearchOptions &&
          <SearchOptions
              faq_kind_list={faqHooks.conditionList?.faq_kind_list}
              faq_type_list={faqHooks.conditionList?.faq_type_list}
              onClickCheckType={faqHooks.onClickCheckType}
              onClickCheckKind={faqHooks.onClickCheckKind}
              checkTypeIds={faqHooks.checkTypeIds}
              checkKindIds={faqHooks.checkKindIds}
          />}
      {faqHooks.isShowKeywordList &&
          <KeywordList
              faq_keyword_list={faqHooks.conditionList?.faq_keyword_list}
              onClickKeyword={faqHooks.onClickKeyword}
          />}
      {(faqHooks.isShowSearchOptions || faqHooks.isShowKeywordList) && (
        <div className="uk-flex uk-flex-center uk-margin-top">
          <button className="button-search" onClick={faqHooks.onClickSearch}>検索</button>
          <button className="button-light uk-margin-left" onClick={faqHooks.onClickReset}>
            リセット
          </button>
        </div>
      )}
    </div>
  )
}